export default __webpack_public_path__ + "static/media/14.0604657d.jpg";